import Config from "services/config/config";
import callWebService, { callTypes } from "services/utils/networks/network";
import { POST_SALES_SUPPLY } from "./type";

export const postSupply = (leadId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    "",
    `${Config.postSales.supply}${leadId}`
  );
  if (res?.data?.status === true) {
    const { data } = res;
    dispatch({ type: POST_SALES_SUPPLY, payload: data.response.data });
    return true;
  }
};
